import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

// Declare Clover SDK types
declare global {
    interface Window {
        Clover: any;
    }
}
// All countries from database
const COUNTRIES = [
    { id: 1, name: 'Mexico' },
    { id: 2, name: 'United States' },
    { id: 3, name: 'Aruba' },
    { id: 4, name: 'Afghanistan' },
    { id: 5, name: 'Angola' },
    { id: 6, name: 'Anguilla' },
    { id: 7, name: 'Åland Islands' },
    { id: 8, name: 'Albania' },
    { id: 9, name: 'Andorra' },
    { id: 10, name: 'Netherlands Antilles' },
    { id: 11, name: 'United Arab Emirates' },
    { id: 12, name: 'Argentina' },
    { id: 13, name: 'Armenia' },
    { id: 14, name: 'American Samoa' },
    { id: 15, name: 'Antarctica' },
    { id: 16, name: 'French Southern Territories' },
    { id: 17, name: 'Antigua and Barbuda' },
    { id: 18, name: 'Australia' },
    { id: 19, name: 'Austria' },
    { id: 20, name: 'Azerbaijan' },
    { id: 21, name: 'Burundi' },
    { id: 22, name: 'Belgium' },
    { id: 23, name: 'Benin' },
    { id: 24, name: 'Burkina Faso' },
    { id: 25, name: 'Bangladesh' },
    { id: 26, name: 'Bulgaria' },
    { id: 27, name: 'Bahrain' },
    { id: 28, name: 'Bahamas' },
    { id: 29, name: 'Bosnia and Herzegovina' },
    { id: 30, name: 'Saint Barthélemy' },
    { id: 31, name: 'Belarus' },
    { id: 32, name: 'Belize' },
    { id: 33, name: 'Bermuda' },
    { id: 34, name: 'Bolivia, Plurinational State of' },
    { id: 35, name: 'Brazil' },
    { id: 36, name: 'Barbados' },
    { id: 37, name: 'Brunei Darussalam' },
    { id: 38, name: 'Bhutan' },
    { id: 39, name: 'Bouvet Island' },
    { id: 40, name: 'Botswana' },
    { id: 41, name: 'Central African Republic' },
    { id: 42, name: 'Canada' },
    { id: 43, name: 'Cocos (Keeling) Islands' },
    { id: 44, name: 'Switzerland' },
    { id: 45, name: 'Chile' },
    { id: 46, name: 'China' },
    { id: 47, name: 'Cote dIvoire' },
    { id: 48, name: 'Cameroon' },
    { id: 49, name: 'Congo, Democratic Republic' },
    { id: 50, name: 'Congo' },
    { id: 51, name: 'Cook Islands' },
    { id: 52, name: 'Colombia' },
    { id: 53, name: 'Comoros' },
    { id: 54, name: 'Cape Verde' },
    { id: 55, name: 'Costa Rica' },
    { id: 56, name: 'Cuba' },
    { id: 57, name: 'Christmas Island' },
    { id: 58, name: 'Cayman Islands' },
    { id: 59, name: 'Cyprus' },
    { id: 60, name: 'Czech Republic' },
    { id: 61, name: 'Germany' },
    { id: 62, name: 'Djibouti' },
    { id: 63, name: 'Dominica' },
    { id: 64, name: 'Denmark' },
    { id: 65, name: 'Dominican Republic' },
    { id: 66, name: 'Algeria' },
    { id: 67, name: 'Ecuador' },
    { id: 68, name: 'Egypt' },
    { id: 69, name: 'Eritrea' },
    { id: 70, name: 'Western Sahara' },
    { id: 71, name: 'Spain' },
    { id: 72, name: 'Estonia' },
    { id: 73, name: 'Ethiopia' },
    { id: 74, name: 'Finland' },
    { id: 75, name: 'Fiji' },
    { id: 76, name: 'Falkland Islands (Malvinas)' },
    { id: 77, name: 'France' },
    { id: 78, name: 'Faroe Islands' },
    { id: 79, name: 'Micronesia, Federated States of' },
    { id: 80, name: 'Gabon' },
    { id: 81, name: 'United Kingdom' },
    { id: 82, name: 'Georgia' },
    { id: 83, name: 'Guernsey' },
    { id: 84, name: 'Ghana' },
    { id: 85, name: 'Gibraltar' },
    { id: 86, name: 'Guinea' },
    { id: 87, name: 'Guadeloupe' },
    { id: 88, name: 'Gambia' },
    { id: 89, name: 'Guinea-Bissau' },
    { id: 90, name: 'Equatorial Guinea' },
    { id: 91, name: 'Greece' },
    { id: 92, name: 'Grenada' },
    { id: 93, name: 'Greenland' },
    { id: 94, name: 'Guatemala' },
    { id: 95, name: 'French Guiana' },
    { id: 96, name: 'Guam' },
    { id: 97, name: 'Guyana' },
    { id: 98, name: 'Hong Kong' },
    { id: 99, name: 'Heard Island and McDonald Islands' },
    { id: 100, name: 'Honduras' },
    { id: 101, name: 'Croatia' },
    { id: 102, name: 'Haiti' },
    { id: 103, name: 'Hungary' },
    { id: 104, name: 'Indonesia' },
    { id: 105, name: 'Isle of Man' },
    { id: 106, name: 'India' },
    { id: 107, name: 'British Indian Ocean Territory' },
    { id: 108, name: 'Ireland' },
    { id: 109, name: 'Iran, Islamic Republic of' },
    { id: 110, name: 'Iraq' },
    { id: 111, name: 'Iceland' },
    { id: 112, name: 'Israel' },
    { id: 113, name: 'Italy' },
    { id: 114, name: 'Jamaica' },
    { id: 115, name: 'Jersey' },
    { id: 116, name: 'Jordan' },
    { id: 117, name: 'Japan' },
    { id: 118, name: 'Kazakhstan' },
    { id: 119, name: 'Kenya' },
    { id: 120, name: 'Kyrgyzstan' },
    { id: 121, name: 'Cambodia' },
    { id: 122, name: 'Kiribati' },
    { id: 123, name: 'Saint Kitts and Nevis' },
    { id: 124, name: 'Korea, Republic of' },
    { id: 125, name: 'Kuwait' },
    { id: 126, name: 'Lao People Democratic Republic' },
    { id: 127, name: 'Lebanon' },
    { id: 128, name: 'Liberia' },
    { id: 129, name: 'Libyan Arab Jamahiriya' },
    { id: 130, name: 'Saint Lucia' },
    { id: 131, name: 'Liechtenstein' },
    { id: 132, name: 'Sri Lanka' },
    { id: 133, name: 'Lesotho' },
    { id: 134, name: 'Lithuania' },
    { id: 135, name: 'Luxembourg' },
    { id: 136, name: 'Latvia' },
    { id: 137, name: 'Macao' },
    { id: 138, name: 'Saint Martin (French part)' },
    { id: 139, name: 'Morocco' },
    { id: 140, name: 'Monaco' },
    { id: 141, name: 'Moldova, Republic of' },
    { id: 142, name: 'Madagascar' },
    { id: 143, name: 'Maldives' },
    { id: 144, name: 'Marshall Islands' },
    { id: 145, name: 'Macedonia' },
    { id: 146, name: 'Mali' },
    { id: 147, name: 'Malta' },
    { id: 148, name: 'Myanmar' },
    { id: 149, name: 'Montenegro' },
    { id: 150, name: 'Mongolia' },
    { id: 151, name: 'Northern Mariana Islands' },
    { id: 152, name: 'Mozambique' },
    { id: 153, name: 'Mauritania' },
    { id: 154, name: 'Montserrat' },
    { id: 155, name: 'Martinique' },
    { id: 156, name: 'Mauritius' },
    { id: 157, name: 'Malawi' },
    { id: 158, name: 'Malaysia' },
    { id: 159, name: 'Mayotte' },
    { id: 160, name: 'Namibia' },
    { id: 161, name: 'New Caledonia' },
    { id: 162, name: 'Niger' },
    { id: 163, name: 'Norfolk Island' },
    { id: 164, name: 'Nigeria' },
    { id: 165, name: 'Nicaragua' },
    { id: 166, name: 'Niue' },
    { id: 167, name: 'Netherlands' },
    { id: 168, name: 'Norway' },
    { id: 169, name: 'Nepal' },
    { id: 170, name: 'Nauru' },
    { id: 171, name: 'New Zealand' },
    { id: 172, name: 'Oman' },
    { id: 173, name: 'Pakistan' },
    { id: 174, name: 'Panama' },
    { id: 175, name: 'Pitcairn' },
    { id: 176, name: 'Peru' },
    { id: 177, name: 'Philippines' },
    { id: 178, name: 'Palau' },
    { id: 179, name: 'Papua New Guinea' },
    { id: 180, name: 'Poland' },
    { id: 181, name: 'Puerto Rico' },
    { id: 182, name: 'Korea, Democratic Republic' },
    { id: 183, name: 'Portugal' },
    { id: 184, name: 'Paraguay' },
    { id: 185, name: 'Palestinian Territory, Occupied' },
    { id: 186, name: 'French Polynesia' },
    { id: 187, name: 'Qatar' },
    { id: 188, name: 'Réunion' },
    { id: 189, name: 'Romania' },
    { id: 190, name: 'Russian Federation' },
    { id: 191, name: 'Rwanda' },
    { id: 192, name: 'Saudi Arabia' },
    { id: 193, name: 'Sudan' },
    { id: 194, name: 'Senegal' },
    { id: 195, name: 'Singapore' },
    { id: 196, name: 'South Georgia and Sandwich Isl' },
    { id: 197, name: 'Saint Helena, Ascension and Tristan' },
    { id: 198, name: 'Svalbard and Jan Mayen' },
    { id: 199, name: 'Solomon Islands' },
    { id: 200, name: 'Sierra Leone' },
    { id: 201, name: 'El Salvador' },
    { id: 202, name: 'San Marino' },
    { id: 203, name: 'Somalia' },
    { id: 204, name: 'Saint Pierre and Miquelon' },
    { id: 205, name: 'Serbia' },
    { id: 206, name: 'Sao Tome and Principe' },
    { id: 207, name: 'Suriname' },
    { id: 208, name: 'Slovakia' },
    { id: 209, name: 'Slovenia' },
    { id: 210, name: 'Sweden' },
    { id: 211, name: 'Swaziland' },
    { id: 212, name: 'Seychelles' },
    { id: 213, name: 'Syrian Arab Republic' },
    { id: 214, name: 'Turks and Caicos Islands' },
    { id: 215, name: 'Chad' },
    { id: 216, name: 'Togo' },
    { id: 217, name: 'Thailand' },
    { id: 218, name: 'Tajikistan' },
    { id: 219, name: 'Tokelau' },
    { id: 220, name: 'Turkmenistan' },
    { id: 221, name: 'Timor-Leste' },
    { id: 222, name: 'Tonga' },
    { id: 223, name: 'Trinidad and Tobago' },
    { id: 224, name: 'Tunisia' },
    { id: 225, name: 'Turkey' },
    { id: 226, name: 'Tuvalu' },
    { id: 227, name: 'Taiwan, Province of China' },
    { id: 228, name: 'Tanzania, United Republic of' },
    { id: 229, name: 'Uganda' },
    { id: 230, name: 'Ukraine' },
    { id: 231, name: 'United States Minor Outlying Isl' },
    { id: 232, name: 'Uruguay' },
    { id: 233, name: 'Uzbekistan' },
    { id: 234, name: 'Holy See (Vatican City State)' },
    { id: 235, name: 'Saint Vincent and the Grenadines' },
    { id: 236, name: 'Venezuela, Bolivarian Republic of' },
    { id: 237, name: 'Virgin Islands, British' },
    { id: 238, name: 'Virgin Islands, U.S.' },
    { id: 239, name: 'Viet Nam' },
    { id: 240, name: 'Vanuatu' },
    { id: 241, name: 'Wallis and Futuna' },
    { id: 242, name: 'Samoa' },
    { id: 243, name: 'Yemen' },
    { id: 244, name: 'South Africa' },
    { id: 245, name: 'Zambia' },
    { id: 246, name: 'Zimbabwe' },
];

// Mexican states (IDs 1-32)
const MEXICAN_STATES = [
    { id: 1, name: 'Aguascalientes' },
    { id: 2, name: 'Baja California' },
    { id: 3, name: 'Baja California Sur' },
    { id: 4, name: 'Campeche' },
    { id: 5, name: 'Chiapas' },
    { id: 6, name: 'Chihuahua' },
    { id: 7, name: 'Coahuila' },
    { id: 8, name: 'Colima' },
    { id: 9, name: 'Ciudad de México' },
    { id: 10, name: 'Durango' },
    { id: 11, name: 'Guanajuato' },
    { id: 12, name: 'Guerrero' },
    { id: 13, name: 'Hidalgo' },
    { id: 14, name: 'Jalisco' },
    { id: 15, name: 'Estado de México' },
    { id: 16, name: 'Michoacán' },
    { id: 17, name: 'Morelos' },
    { id: 18, name: 'Nayarit' },
    { id: 19, name: 'Nuevo León' },
    { id: 20, name: 'Oaxaca' },
    { id: 21, name: 'Puebla' },
    { id: 22, name: 'Querétaro' },
    { id: 23, name: 'Quintana Roo' },
    { id: 24, name: 'San Luis Potosí' },
    { id: 25, name: 'Sinaloa' },
    { id: 26, name: 'Sonora' },
    { id: 27, name: 'Tabasco' },
    { id: 28, name: 'Tamaulipas' },
    { id: 29, name: 'Tlaxcala' },
    { id: 30, name: 'Veracruz' },
    { id: 31, name: 'Yucatán' },
    { id: 32, name: 'Zacatecas' },
];

// US states (IDs 33-82)
const US_STATES = [
    { id: 33, name: 'Alaska', code: 'AK' },
    { id: 34, name: 'Alabama', code: 'AL' },
    { id: 35, name: 'Arkansas', code: 'AR' },
    { id: 36, name: 'Arizona', code: 'AZ' },
    { id: 37, name: 'California', code: 'CA' },
    { id: 38, name: 'Colorado', code: 'CO' },
    { id: 39, name: 'Connecticut', code: 'CT' },
    { id: 40, name: 'Delaware', code: 'DE' },
    { id: 41, name: 'Florida', code: 'FL' },
    { id: 42, name: 'Georgia', code: 'GA' },
    { id: 43, name: 'Hawaii', code: 'HI' },
    { id: 44, name: 'Iowa', code: 'IA' },
    { id: 45, name: 'Idaho', code: 'ID' },
    { id: 46, name: 'Illinois', code: 'IL' },
    { id: 47, name: 'Indiana', code: 'IN' },
    { id: 48, name: 'Kansas', code: 'KS' },
    { id: 49, name: 'Kentucky', code: 'KY' },
    { id: 50, name: 'Louisiana', code: 'LA' },
    { id: 51, name: 'Massachusetts', code: 'MA' },
    { id: 52, name: 'Maryland', code: 'MD' },
    { id: 53, name: 'Maine', code: 'ME' },
    { id: 54, name: 'Michigan', code: 'MI' },
    { id: 55, name: 'Minnesota', code: 'MN' },
    { id: 56, name: 'Missouri', code: 'MO' },
    { id: 57, name: 'Mississippi', code: 'MS' },
    { id: 58, name: 'Montana', code: 'MT' },
    { id: 59, name: 'North Carolina', code: 'NC' },
    { id: 60, name: 'North Dakota', code: 'ND' },
    { id: 61, name: 'Nebraska', code: 'NE' },
    { id: 62, name: 'New Hampshire', code: 'NH' },
    { id: 63, name: 'New Jersey', code: 'NJ' },
    { id: 64, name: 'New Mexico', code: 'NM' },
    { id: 65, name: 'Nevada', code: 'NV' },
    { id: 66, name: 'New York', code: 'NY' },
    { id: 67, name: 'Ohio', code: 'OH' },
    { id: 68, name: 'Oklahoma', code: 'OK' },
    { id: 69, name: 'Oregon', code: 'OR' },
    { id: 70, name: 'Pennsylvania', code: 'PA' },
    { id: 71, name: 'Rhode Island', code: 'RI' },
    { id: 72, name: 'South Carolina', code: 'SC' },
    { id: 73, name: 'South Dakota', code: 'SD' },
    { id: 74, name: 'Tennessee', code: 'TN' },
    { id: 75, name: 'Texas', code: 'TX' },
    { id: 76, name: 'Utah', code: 'UT' },
    { id: 77, name: 'Virginia', code: 'VA' },
    { id: 78, name: 'Vermont', code: 'VT' },
    { id: 79, name: 'Washington', code: 'WA' },
    { id: 80, name: 'Wisconsin', code: 'WI' },
    { id: 81, name: 'West Virginia', code: 'WV' },
    { id: 82, name: 'Wyoming', code: 'WY' },
];

// Helper function to get N/A state ID for a country
const getNAStateId = (countryId: number) => {
    if (countryId <= 2) return null;
    return 83 + (countryId - 3);
};

const CheckoutClover: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // Restore checkout state from React Router state (first visit) or localStorage (returning from Stripe redirect)
    const [checkoutState] = useState<any>(() => {
        if (location.state?.tournament) {
            localStorage.setItem('pendingCheckoutState', JSON.stringify(location.state));
            return location.state;
        }
        const saved = localStorage.getItem('pendingCheckoutState');
        if (saved) {
            try { return JSON.parse(saved); } catch { return null; }
        }
        return null;
    });
    const { tournament, player, packages, recruiterMode } = checkoutState || {};

    const [address, setAddress] = useState({ street: '', city: '', state: '', country: '', zip: '' });
    const [billingAddress, setBillingAddress] = useState({ street: '', city: '', state: '', country: '', zip: '' });
    const [billingSame, setBillingSame] = useState(true);
    const [comments, setComments] = useState('');
    const [paymentType, setPaymentType] = useState('Card');
    const [isLoading, setIsLoading] = useState(false);
    const [checkoutError, setCheckoutError] = useState('');
    const [ErrorModal, setErrorModal] = useState(false);
    const [webFeePaid, setWebFeePaid] = useState<boolean | null>(null);
    const [webFeeLoading, setWebFeeLoading] = useState(false);
    const totalCost = (packages || []).reduce((sum: number, pkg: any) => sum + (Number(pkg.costo) || 0), 0);
    const isGermanTax = tournament?.cveBoliche === 17;
    const totalWithFees = isGermanTax ? totalCost * 1.03 : totalCost * 1.05;
    // Clover-specific state
    const [cloverLoaded, setCloverLoaded] = useState(false);
    const cloverRef = useRef<any>(null);
    

    // Environment variables for Clover
    const CLOVER_PAKMS_KEY = process.env.REACT_APP_CLOVER_PAKMS_KEY || 'dummy_pakms_key_replace_with_real';

    useEffect(() => {
        if (!tournament || !player || !packages) {
            navigate('/');
            return;
        }
        
        // Initialize Clover SDK when component mounts (only for Card payment)
        if (paymentType === 'Card' && window.Clover) {
            initializeClover();
        }
        return () => {
            // Remove Clover iframes from field containers
            const ids = ['card-number', 'card-date', 'card-cvv', 'card-postal-code'];
            ids.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    while (el.firstChild) {
                        el.removeChild(el.firstChild);
                    }
                }
            });
            cloverRef.current = null;
        };
    }, [tournament, player, packages, paymentType, navigate]);

    // Pin Clover's compliance branding to the bottom-right corner so it never
    // pushes content or gets clipped by our layout containers.
    // Uses a MutationObserver so it catches the element whenever Clover injects it.
    useEffect(() => {
        const pinCloverBranding = (el: HTMLElement) => {
            el.style.position = 'fixed';
            el.style.bottom = '0';
            el.style.right = '0';
            el.style.left = 'auto';
            el.style.width = 'auto';
            el.style.maxWidth = '100vw';
            el.style.zIndex = '9999';
            el.style.margin = '0';
            el.style.padding = '4px 12px';
            el.style.boxSizing = 'border-box';
        };

        // Apply to any already-present Clover body elements
        const reactRoot = document.getElementById('root');
        document.querySelectorAll<HTMLElement>('[id*="clover" i], [class*="clover" i]').forEach(el => {
            if (reactRoot && !reactRoot.contains(el)) pinCloverBranding(el);
        });

        // Watch for Clover injecting its element asynchronously
        const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
                m.addedNodes.forEach(node => {
                    if (node instanceof HTMLElement) {
                        const id = node.id?.toLowerCase() ?? '';
                        const cls = node.className?.toLowerCase() ?? '';
                        if ((id.includes('clover') || cls.includes('clover')) &&
                            !document.getElementById('root')?.contains(node)) {
                            pinCloverBranding(node);
                        }
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: false });

        return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Check platform fee status on component mount
    useEffect(() => {
        if (!player || !tournament) return;
        const checkWebFee = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/webfee-status?jugadorClave=${player.CLAVE}&tournamentClave=${tournament.clave}`);
                const data = await res.json();
                setWebFeePaid(data.webFeePaid === true);
            } catch {
                setWebFeePaid(false);
            }
        };
        checkWebFee();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [player?.CLAVE, tournament?.clave]);

    // Handle return from Stripe platform fee Checkout page
    useEffect(() => {
        const webfeeParam = searchParams.get('webfee');
        const stripeSessionId = searchParams.get('stripe_session_id');
        if (webfeeParam === 'paid' && stripeSessionId && player && tournament) {
            const confirmFee = async () => {
                setWebFeeLoading(true);
                try {
                    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/confirm-platform-fee`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            stripeSessionId,
                            jugadorClave: player.CLAVE,
                            tournamentClave: tournament.clave
                        })
                    });
                    if (resp.ok) {
                        setWebFeePaid(true);
                        // Clear Stripe redirect params so a page refresh doesn't re-confirm
                        window.history.replaceState({}, '', window.location.pathname);
                    } else {
                        // Fallback: re-check DB status in case webhook already updated it
                        const statusRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/webfee-status?jugadorClave=${player.CLAVE}&tournamentClave=${tournament.clave}`);
                        const statusData = await statusRes.json();
                        setWebFeePaid(statusData.webFeePaid === true);
                        if (statusData.webFeePaid === true) {
                            window.history.replaceState({}, '', window.location.pathname);
                        }
                    }
                } catch {
                    setWebFeePaid(false);
                } finally {
                    setWebFeeLoading(false);
                }
            };
            confirmFee();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, player?.CLAVE, tournament?.clave]);

    const handlePlatformFeePayment = async () => {
        setWebFeeLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/platform-fee-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    jugadorClave: player.CLAVE,
                    tournamentClave: tournament.clave,
                    tournamentName: tournament.nombre
                })
            });
            const data = await res.json();
            if (data.alreadyPaid) {
                // Guard on backend detected fee already paid — no charge needed
                setWebFeePaid(true);
                setWebFeeLoading(false);
            } else if (data.url) {
                window.location.href = data.url;
            } else {
                throw new Error(data.error || 'Failed to create payment session');
            }
        } catch (error: any) {
            setWebFeeLoading(false);
            setCheckoutError(error.message || 'Failed to initiate platform fee payment');
            setErrorModal(true);
        }
    };

    const initializeClover = () => {
        try {
            const clover = new window.Clover(CLOVER_PAKMS_KEY);
            cloverRef.current = clover;

            const elements = clover.elements();

            // Create and mount card number element
            const cardNumber = elements.create('CARD_NUMBER', {
                style: {
                    base: {
                        fontSize: '16px',
                        fontFamily: 'Arial, sans-serif',
                        color: '#333',
                        '::placeholder': { color: '#aaa' }
                    }
                }
            });


            // Create and mount card date element
            const cardDate = elements.create('CARD_DATE', {
                style: {
                    base: {
                        fontSize: '16px',
                        fontFamily: 'Arial, sans-serif',
                        color: '#333',
                        '::placeholder': { color: '#aaa' }
                    }
                }
            });


            // Create and mount CVV element
            const cardCvv = elements.create('CARD_CVV', {
                style: {
                    base: {
                        fontSize: '16px',
                        fontFamily: 'Arial, sans-serif',
                        color: '#333',
                        '::placeholder': { color: '#aaa' }
                    }
                }
            });


            // Create and mount postal code element
            const cardPostal = elements.create('CARD_POSTAL_CODE', {
                style: {
                    base: {
                        fontSize: '16px',
                        fontFamily: 'Arial, sans-serif',
                        color: '#333',
                        '::placeholder': { color: '#aaa' }
                    }
                }
            });
            cardNumber.mount('#card-number');
            cardDate.mount('#card-date');
            cardCvv.mount('#card-cvv');
            cardPostal.mount('#card-postal-code');

            setCloverLoaded(true);
        } catch (error) {
            console.error('Error initializing Clover:', error);
            setCheckoutError('Failed to initialize payment system. Please try again.');
            setErrorModal(true);
        }
    };



    const handleCheckout = async () => {
        setIsLoading(true);
        setCheckoutError('');

        const finalAddress = address;
        const finalBillingAddress = billingSame ? address : billingAddress;
        console.log('Final Address:', finalAddress, 'Billing Address:', finalBillingAddress, comments, paymentType, totalCost, packages, tournament.clave, player.CLAVE, player.FICHANAL, packages[0]?.divisionClave);

        try {
            // Step 1: Call backend checkout endpoint
            const checkoutResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clover-checkout`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    tournamentClave: tournament.clave,
                    jugadorClave: player.CLAVE,
                    jugadorTAT: player.FICHANAL,
                    vendedorClave: -2, // Change to -2 for production
                    divisionClave: packages[0]?.divisionClave || null,
                    packages,
                    address: finalAddress,
                    billingAddress: finalBillingAddress,
                    comments,
                    paymentType,
                    totalCost,
                    recruiterClave: recruiterMode
                        ? (() => { try { return JSON.parse(localStorage.getItem('loggedInPlayer') || '{}').CLAVE || null; } catch { return null; } })()
                        : null
                })
            });

            const checkoutData = await checkoutResponse.json();

            if (!checkoutResponse.ok) {
                throw new Error(checkoutData.error || 'Checkout failed');
            }

            // Step 2: Handle based on payment type
            if (paymentType === 'Card' && checkoutData.requiresCloverPayment) {
                // Card payment: Generate Clover token and process payment
                if (!cloverRef.current) {
                    throw new Error('Clover payment system not initialized');
                }

                // Generate token from Clover iframe elements
                const tokenResult = await cloverRef.current.createToken();

                if (tokenResult.errors) {
                    const errorMessages = Object.values(tokenResult.errors).join(', ');
                    throw new Error(`Card validation failed: ${errorMessages}`);
                }

                if (!tokenResult.token) {
                    throw new Error('Failed to generate payment token');
                }
                console.log('Clover Token:', tokenResult.token, tournament.clave, player.CLAVE, packages, finalAddress, comments, totalCost, paymentType);

                // Step 3: Send token to backend to create charge
                const chargeResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clover-charge`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        cloverToken: tokenResult.token,
                        tournamentClave: tournament.clave,
                        jugadorClave: player.CLAVE,
                        vendedorClave: -2, // Change to -2 for production
                        packages,
                        address: finalAddress,
                        comments,
                        totalCost,
                        paymentType
                    })
                });

                const chargeData = await chargeResponse.json();

                if (!chargeResponse.ok) {
                    throw new Error(chargeData.error || 'Payment failed');
                }

                // Payment successful - store data for success page
                localStorage.setItem('successData', JSON.stringify({
                    player,
                    tournament,
                    packages,
                    totalCost: totalWithFees,
                    paymentType: 'Card',
                    last4: chargeData.last4 ?? null
                }));
				localStorage.setItem('player_email', player.EMAIL || '');
                localStorage.removeItem('pendingCheckoutState');

                // Navigate to success page
                navigate('/success');
            } else {
                // Non-card payment (Zelle/Check) - already processed on backend
                localStorage.setItem('successData', JSON.stringify({
                    player,
                    tournament,
                    packages,
                    totalCost,
                    paymentType
                }));
				localStorage.setItem('player_email', player.EMAIL || '');
                localStorage.removeItem('pendingCheckoutState');

                navigate('/success');
            }
        } catch (error: any) {
            console.error('Checkout error:', error);
            setCheckoutError(error.message || 'An error occurred during checkout');
            setErrorModal(true);
        } finally {
            setIsLoading(false);
        }
    };

    const SummaryCard = () => (
        <div className="bg-white shadow rounded-lg p-6 w-full">
            <h2 className="text-xl font-bold mb-4 text-blue-700">Order Summary</h2>
            <div className="mb-2"><b>Tournament:</b> {tournament.nombre}</div>
            <div className="mb-2"><b>Player:</b> {player.NOMBRECOMPLETO}</div>
            <div className="mb-4"><b>TAT:</b> {player.FICHANAL}</div>
            <hr className="my-4" />
            {packages.map((pkg: any) => (
                <div key={pkg.paqueteClave} className="mb-4 border-l-4 border-blue-300 pl-4">
                    <div className="mb-2"><b>Package:</b> {pkg.paqueteDescripcion}</div>
                    <div className="mb-2"><b>Division:</b> {pkg.divisionDescripcion}</div>
                    {Array.isArray(pkg.items) && pkg.items.length > 0 && (
                        <div className="mb-2"><b>Items:</b></div>
                    )}
                    <ul className="list-none ml-6 mb-4">
                        {(pkg.items || []).map((item: any) => (
                            <li key={item.CVEITEM}>
                                {item.cantidad} {item.item}
                            </li>
                        ))}
                    </ul>
                    {Array.isArray(pkg.eventos) && pkg.eventos.length > 0 && (
                        <div className="mb-2"><b>Schedule:</b></div>
                    )}
                    <ul className="list-none ml-6">
                        {(pkg.eventos || []).map((ev: any) => (
                            <li key={ev.CVEEVENTO}>
                                <span className="font-semibold">{ev.evento}:</span>
                                <ul className="ml-4">
                                    {ev.turnosInfo
                                        .slice()
                                        .sort((a: any, b: any) => a.TURNO - b.TURNO)
                                        .map((turno: any, i: number) => (
                                            <li key={i}>
                                                {turno.HORARIO_I} {(turno.waitlist === 1) ? '(Waitlist)' : ''}
                                            </li>
                                        ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <div className="min-h-screen bg-gray-50 px-4 py-6 sm:px-6">
            <div className="max-w-5xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-6">
                {/* Checkout Summary */}
                <div className="w-full lg:w-2/5 flex-shrink-0">
                    <SummaryCard />
                </div>

                {/* Forms Card */}
                <div className="bg-white shadow rounded-lg p-6 w-full lg:flex-1">
                    <h2 className="text-xl font-bold mb-4 text-blue-700">Player & Payment Info</h2>
                    <div className="mb-4 text-sm text-gray-700">
                        If you have bowled in the last 3 years only enter your address if it has changed.
                    </div>
                    {/* Address Form */}
                    <div className="mb-4">
                        <label className="block font-semibold mb-1">Address</label>
                        <input
                            className="w-full border rounded px-3 py-2 mb-2"
                            placeholder="Street"
                            value={address.street}
                            onChange={e => setAddress({ ...address, street: e.target.value })}
                        />
                        <input
                            className="w-full border rounded px-3 py-2 mb-2"
                            placeholder="City"
                            value={address.city}
                            onChange={e => setAddress({ ...address, city: e.target.value })}
                        />
                        <div className="flex gap-2 mb-2">
                            <select
                                className="flex-1 border rounded px-3 py-2 bg-white"
                                value={address.country}
                                onChange={e => {
                                    setAddress({ ...address, country: e.target.value, state: '' });
                                }}
                            >
                                <option value="">Select Country</option>
                                {COUNTRIES.map(country => (
                                    <option key={country.id} value={country.id}>
                                        {country.name}
                                    </option>
                                ))}
                            </select>
                            <select
                                className="flex-1 border rounded px-3 py-2 bg-white"
                                value={address.state}
                                onChange={e => setAddress({ ...address, state: e.target.value })}
                                disabled={!address.country}
                            >
                                <option value="">State</option>
                                {address.country === '1' && MEXICAN_STATES.map(state => (
                                    <option key={state.id} value={state.id}>
                                        {state.name}
                                    </option>
                                ))}
                                {address.country === '2' && US_STATES.map(state => (
                                    <option key={state.id} value={state.id}>
                                        {state.code}
                                    </option>
                                ))}
                                {address.country && address.country !== '1' && address.country !== '2' && (
                                    <option value={getNAStateId(Number(address.country)) || ''}>
                                        N/A
                                    </option>
                                )}
                            </select>
                        </div>
                        <input
                            className="w-full border rounded px-3 py-2"
                            placeholder="ZIP"
                            value={address.zip}
                            onChange={e => setAddress({ ...address, zip: e.target.value })}
                        />
                    </div>
                    {/* Billing Address Checkbox */}
                    <div className="mb-4 flex items-center">
                        <input
                            type="checkbox"
                            checked={billingSame}
                            onChange={e => setBillingSame(e.target.checked)}
                            id="billingSame"
                            className="mr-2"
                        />
                        <label htmlFor="billingSame" className="text-sm">
                            Billing address same as on file
                        </label>
                    </div>
                    {/* Comments */}
                    <div className="mb-4">
                        <label className="block font-semibold mb-1">Comments</label>
                        <textarea
                            className="w-full border rounded px-3 py-2"
                            rows={3}
                            value={comments}
                            onChange={e => setComments(e.target.value)}
                            placeholder="Any additional comments or requests..."
                        ></textarea>
                    </div>
                    {/* Payment Type */}
                    <div className="mb-4">
                        <label className="block font-semibold mb-1">Payment Type</label>
                        {isGermanTax ? (
                            <select
                            className="w-full border rounded px-3 py-2"
                            value={paymentType}
                            onChange={e => setPaymentType(e.target.value)}
                        >
                            <option value="Card">Card (3% CC fee)</option>
                            <option value="IN-PERSON">In-Person</option>
                        </select>
                        ) : (

                        <select
                            className="w-full border rounded px-3 py-2"
                            value={paymentType}
                            onChange={e => setPaymentType(e.target.value)}
                        >
                            <option value="Check">Check</option>
                            {player.CVEPAIS === 2 ? (
                                <option value="Zelle">Zelle</option>
                            ) : (
                                <option value="IN-PERSON">In-Person</option>
                            )}
                            <option value="Card">Card</option>
                        </select>)}
                    </div>


                    {/* Clover Card Elements (only show for Card payment) */}
                    {paymentType === 'Card' && (
                        <div className="mb-4">
                            <div className="mb-4 bg-green-50 border-l-4 border-green-400 p-3 text-sm">
                                <div className="mb-2 font-semibold">Credit Card Payment</div>
                                {isGermanTax ? (
                                    <>
                                        <div><b>German Sales Tax is already included in the cost.</b></div>
                                        <div className="mt-1"><b>3% credit card processing fee applies.</b></div>
                                    </>
                                ) : (
                                    <div><b>5% processing fee applies.</b></div>
                                )}
                            </div>

                            <label className="block font-semibold mb-2">Card Information</label>

                            {/* Card Number */}


                            <div
                                id="card-number"
                                className="field card-number"
                            ></div>
                            <div id="card-number-errors" role="alert" className="text-red-600 text-sm mt-1"></div>


                            {/* Card Date and CVV */}
                            <div className="flex gap-2">
                                <div className="w-1/2">

                                    <div
                                        id="card-date"
                                        className="field card-date"
                                    ></div>
                                    <div id="card-date-errors" role="alert" className="text-red-600 text-sm mt-1"></div>
                                </div>
                                <div className="w-1/2">

                                    <div
                                        id="card-cvv"
                                        className="field card-cvv"
                                    ></div>
                                    <div id="card-cvv-errors" role="alert" className="text-red-600 text-sm mt-1"></div>
                                </div>
                            </div>

                            {/* Postal Code */}


                            <div
                                id="card-postal-code"
                                className="field card-postal"
                            ></div>
                            <div id="card-postal-errors" role="alert" className="text-red-600 text-sm mt-1"></div>

                            <div id="card-response" role="alert" className="text-red-600 text-sm mt-1"></div>
                        </div>
                    )}

                    {/* Payment Instructions for non-card payments */}
                    {/* Payment Instructions */}
                    {paymentType === 'Zelle' && (
                        <div className="mb-4 bg-blue-50 border-l-4 border-blue-400 p-3 text-sm">
                            <b>Zelle ID:</b> info@tatbowl.com<br />
                            Please make payment before <b>{new Date(tournament.fechaInicio).toLocaleDateString()}</b>.
                        </div>
                    )}
                    {paymentType === 'Check' && (
                        <div className="mb-4 bg-yellow-50 border-l-4 border-yellow-400 p-3 text-sm">
                            <b>Mail Check To:</b><br />
                            PO BOX 778117<br />
                            Henderson, NV 89077<br />
                            Please mail check at least 10 days before <b>{new Date(tournament.fechaInicio).toLocaleDateString()}</b>.
                        </div>
                    )}

                    <div className="mb-4 text-right text-lg font-bold text-green-700">
                        Total: ${(paymentType === 'Card' ? totalWithFees : totalCost).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </div>
                    <button
                        className={`w-full mt-4 px-4 py-2 rounded font-semibold transition text-white
                            ${(isLoading || ((!recruiterMode || paymentType === 'Card') && webFeePaid !== true))
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700 cursor-pointer'
                            }`}
                        type="button"
                        onClick={handleCheckout}
                        disabled={isLoading || ((!recruiterMode || paymentType === 'Card') && webFeePaid !== true)}
                    >
                        {isLoading ? "Processing..." : "Checkout"}
                    </button>

                    {/* One-time platform registration fee gate */}
                    {/* Recruiter non-card: group balance message instead of gate */}
                    {recruiterMode && paymentType !== 'Card' && (
                        <div className="mt-4 border border-blue-300 rounded-lg bg-blue-50 p-4">
                            <div className="font-semibold text-blue-800 mb-1">Platform Fee — Group Balance</div>
                            <p className="text-sm text-gray-700">
                                A <strong>$10.00 one-time platform registration fee</strong> will be added to your group's balance for this bowler. This fee will be paid by the bowler at the venue.
                            </p>
                        </div>
                    )}
                    {(!recruiterMode || paymentType === 'Card') && webFeePaid === null && (
                        <div className="mt-3 text-sm text-gray-500 text-center animate-pulse">Verifying registration status...</div>
                    )}
                    {(!recruiterMode || paymentType === 'Card') && searchParams.get('webfee') === 'paid' && webFeeLoading && (
                        <div className="mt-3 text-sm text-blue-600 text-center font-medium">Confirming your platform fee payment...</div>
                    )}
                    {(!recruiterMode || paymentType === 'Card') && webFeePaid === false && (
                        <div className="mt-4 border border-amber-300 rounded-lg bg-amber-50 p-4">
                            <div className="font-semibold text-amber-800 mb-1">Platform Registration Fee Required</div>
                            {(() => {
                                const n = (tournament?.nombre || '').toLowerCase();
                                const feeAmount = (n.includes('summer') || n.includes('national')) ? '$10.00' : '$2.00';
                                return (
                                    <>
                                        <p className="text-sm text-gray-700 mb-3">
                                            A one-time <strong>{feeAmount} platform registration fee</strong> is required to complete your
                                            registration for <strong>{tournament?.nombre}</strong>. This fee applies once per tournament
                                            only &mdash; this fee goes to RageTech LLC, the company that develops, maintains, and supports the TAT platforms including the new online portal that gives you access
                                            to tournament registration, rescheduling your own squads, team building, payment processing, past tournament results, lane assignments, group registrations, and 24/7 support.
                                        </p>
                                        <button
                                            className="w-full bg-green-600 text-white px-4 py-2 rounded font-semibold hover:bg-green-700 transition disabled:opacity-50"
                                            type="button"
                                            onClick={handlePlatformFeePayment}
                                            disabled={webFeeLoading}
                                        >
                                            {webFeeLoading ? 'Redirecting to payment...' : `Pay ${feeAmount} — One-Time Platform Fee`}
                                        </button>
                                    </>
                                );
                            })()}
                        </div>
                    )}
                </div>
            </div>
            {/* Error Modal */}
            {ErrorModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                        <h2 className="text-lg font-bold mb-4 text-red-600">Checkout Error</h2>
                        <p className="mb-4">{checkoutError}</p>
                        <button
                            className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 transition"
                            onClick={() => setErrorModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
            </div>
            </div>
        </>
    );
};

export default CheckoutClover;
